import React from 'react';

const Popup = ({ isOpen, title, message, onConfirm, onCancel, type = 'confirm', confirmText, cancelText }) => {
    if (!isOpen) return null;

    const getIcon = () => {
        switch (type) {
            case 'danger': return '⚠️';
            case 'success': return '✅';
            case 'info': return 'ℹ️';
            default: return 'ℹ️';
        }
    };

    return (
        <div className="popup-overlay" onClick={onCancel}>
            <style>{`
                .popup-overlay {
                    position: fixed; top: 0; left: 0; width: 100%; height: 100%;
                    background: rgba(0, 0, 0, 0.7); backdrop-filter: blur(8px);
                    display: flex; align-items: center; justify-content: center;
                    z-index: 9999; animation: popupFadeIn 0.2s ease-out;
                }
                .popup-modal {
                    background: #0f172a; border: 1px solid rgba(99, 102, 241, 0.3);
                    border-radius: 24px; padding: 40px 32px; width: 90%; max-width: 440px;
                    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
                    animation: popupSlideUp 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
                    text-align: center;
                }
                @keyframes popupFadeIn { from { opacity: 0; } to { opacity: 1; } }
                @keyframes popupSlideUp { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }

                .popup-icon { font-size: 3rem; margin-bottom: 24px; }
                .popup-title { font-size: 1.5rem; font-weight: 800; color: #f1f5f9; margin-bottom: 12px; letter-spacing: -0.02em; }
                .popup-message { font-size: 1rem; color: #94a3b8; margin-bottom: 32px; line-height: 1.6; }
                
                .popup-actions { display: flex; gap: 12px; }
                .popup-btn {
                    flex: 1; padding: 14px; border-radius: 12px; font-weight: 700; font-size: 15px;
                    cursor: pointer; transition: all 0.2s; font-family: inherit; border: none;
                }
                .popup-btn-cancel { background: rgba(255, 255, 255, 0.05); color: #64748b; border: 1px solid rgba(255, 255, 255, 0.1); }
                .popup-btn-cancel:hover { background: rgba(255, 255, 255, 0.08); color: #94a3b8; }
                
                .popup-btn-danger { background: linear-gradient(135deg, #ef4444, #b91c1c); color: white; box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3); }
                .popup-btn-danger:hover { transform: translateY(-2px); box-shadow: 0 6px 20px rgba(239, 68, 68, 0.4); }
                
                .popup-btn-primary { background: linear-gradient(135deg, #6366f1, #4f46e5); color: white; box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3); }
                .popup-btn-primary:hover { transform: translateY(-2px); box-shadow: 0 6px 20px rgba(99, 102, 241, 0.4); }
            `}</style>
            <div className="popup-modal" onClick={e => e.stopPropagation()}>
                <div className="popup-icon">{getIcon()}</div>
                {title && <h3 className="popup-title">{title}</h3>}
                <p className="popup-message">{message}</p>
                <div className="popup-actions">
                    {type === 'confirm' || type === 'danger' ? (
                        <>
                            <button className="popup-btn popup-btn-cancel" onClick={onCancel}>{cancelText || 'Cancel'}</button>
                            <button className={`popup-btn ${type === 'danger' ? 'popup-btn-danger' : 'popup-btn-primary'}`} onClick={onConfirm}>
                                {confirmText || (type === 'danger' ? 'Delete' : 'Confirm')}
                            </button>
                        </>
                    ) : (
                        <button className="popup-btn popup-btn-primary" onClick={onConfirm || onCancel}>{confirmText || 'Got it'}</button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Popup;
